// extracted by mini-css-extract-plugin
export default {"page_controls_container":"PageSort_page_controls_container__Dikup","items_controls":"PageSort_items_controls__+Hp75","page_controls":"PageSort_page_controls__th2y3"};